import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { AbstractControl, Validators } from "@angular/forms";

interface RadioOption {
  value: string;
  label: string;
}

@Component({
    selector: "app-radio-button-group",
    templateUrl: "./radio-button-group.component.html",
    styleUrls: ["./radio-button-group.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RadioButtonGroupComponent implements OnInit, OnChanges {
  @Input() label: string = "";
  @Input() options: (string | RadioOption)[] = [];
  @Input() control: AbstractControl | null = null;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() selectedValue: string | null = null;
  @Input() dataId: string;

  ngOnInit() {
    if (this.control) {
      if (this.required) {
        this.control.setValidators(Validators.required);
      } else {
        this.control.clearValidators();
      }
      this.control.updateValueAndValidity();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.control) {
      if (changes["required"]) {
        if (this.required) {
          this.control.setValidators(Validators.required);
        } else {
          this.control.clearValidators();
        }
        this.control.updateValueAndValidity();
      }

      if (changes["disabled"]) {
        this.disabled ? this.control.disable() : this.control.enable();
      }
    }
  }

  get isDisabled(): boolean {
    return this.control && this.control.disabled
      ? this.control.disabled
      : false;
  }

  onSelect(option: string | RadioOption) {
    if (!this.isDisabled && this.control && this.selectedValue === null) {
      const value = typeof option === "string" ? option : option.value;
      this.control.setValue(value);
    }
  }

  isSelected(option: string | RadioOption): boolean {
    const optionValue = typeof option === "string" ? option : option.value;
    if (this.selectedValue !== null) {
      return this.selectedValue === optionValue;
    }
    return this.control && this.control.value === optionValue;
  }

  getOptionLabel(option: string | RadioOption): string {
    return typeof option === "string" ? option : option.label;
  }
}
